import { Link } from "react-router-dom"

import styled, { css } from "styled-components"

import { colors, borderRadius } from "@izettle/otto"

import { focusOutlineMixin } from "../../mixins"

const linkColors = colors.action.secondary

// Extends the background and adds a border
const fakePaddedBorder = (backgroundColor: string, borderColor: string) => css`
  background: ${backgroundColor};
  box-shadow: 0px 0px 0px 2px ${backgroundColor}, 0px 0px 0px 3px ${borderColor};
`

export const linkStylesMixin = css`
  text-decoration-line: underline;
  text-underline-offset: 0.0625rem;
  border-radius: ${borderRadius.small};
  cursor: pointer;

  color: ${linkColors.text.default};
  ${fakePaddedBorder("transparent", "transparent")}

  &:hover {
    color: ${linkColors.text.hover};
    ${fakePaddedBorder(linkColors.background.hover, linkColors.background.hover)}
  }

  &:focus {
    ${focusOutlineMixin}
    outline-offset: 2px;
    color: ${linkColors.text.hover};
  }

  &:active {
    color: ${linkColors.text.selected};
    ${fakePaddedBorder(linkColors.background.selected, linkColors.border.selected)}
  }

  /* override portal global styles */
  font-weight: inherit;
  transition: none;
`

export const TextLink = styled(Link)`
  ${linkStylesMixin}
`

export const TextAnchor = styled.a`
  ${linkStylesMixin}
`
